import { jsx } from "react/jsx-runtime";
import MuiCard from "@mui/material/Card";
function Card({
  color,
  ...props
}) {
  return /* @__PURE__ */ jsx(MuiCard, { color, ...props });
}
export {
  Card
};
//# sourceMappingURL=index.js.map
